var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn-main anim-border",attrs:{"to":_vm.linkTo}},[_c('div',{staticClass:"title font-weight-light"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }